function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h512v512H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M486.868 324.517l-91.853 128.032c-14.446 20.333-42.476 30.122-78.915 27.125-47.004-3.881-109.317-28.72-169.043-71.563-59.725-42.864-103.28-93.922-122.254-137.153-14.446-33.507-14.23-63.089.432-83.443L116.87 59.482c14.662-20.332 42.692-30.121 78.916-27.124C242.79 36.24 305.319 61.1 365.045 103.942c59.725 42.843 103.28 93.9 122.038 137.132 14.662 33.506 14.23 63.11-.215 83.443zM141.45 77.077c9.487-13.153 28.462-16.56 51.964-14.619 42.907 3.536 99.399 26.909 153.95 66.021 54.55 39.091 94.87 85.168 112.12 124.626 9.27 21.626 12.29 40.687 2.802 53.84l12.29 8.775-12.29-8.776-91.852 128.033c-9.271 13.13-28.245 16.559-51.748 14.597-42.907-3.515-99.614-26.909-154.165-66-54.55-39.113-94.87-85.19-111.904-124.626-9.487-21.648-12.29-40.708-2.803-53.839L141.45 77.077z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M129.348 71.389c29.97-41.83 131.525-20.354 226.827 47.91 95.302 68.285 148.344 157.7 118.373 199.53l-91.636 128.033c-29.97 41.829-131.741 20.354-227.044-47.932C60.566 330.645 7.525 241.25 37.496 199.421L129.348 71.39z",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(2.22208 0 0 2.22208 -41298.222 -35383.233)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18640.6 15952.1c6-8.4 17.6-12.1 32.6-10.9 20.7 1.7 48.1 12.8 74.5 31.6 26.3 18.9 45.6 41.4 53.8 60.4 6 13.8 6.2 26 .2 34.4l-41.2 57.6c-6 8.4-17.7 12.1-32.6 10.9-20.7-1.8-48.2-12.8-74.5-31.7-26.4-18.8-45.6-41.3-53.9-60.3-6-13.8-6.2-26-.2-34.4l41.3-57.6zm155.4 111.4v-.1c4.8-6.6 3.8-16.4-.9-27.4-7.9-18.1-26.4-39.4-51.6-57.4-25.1-18-51.2-28.7-70.9-30.3-12-1-21.5 1.2-26.3 7.9l-.2.4c-4.5 6.7-3.5 16.2 1.2 27 7.9 18.2 26.4 39.5 51.5 57.5s51.2 28.7 70.9 30.3c11.8.9 21.1-1.2 26-7.5l.3-.5v.1zm-64.2-68.6c12.6 9 21.9 19.7 25.8 28.8 2.3 5.1 2.9 9.6.6 12.7-2.2 3.1-6.7 4-12.2 3.5-9.9-.8-22.9-6.2-35.5-15.2-12.6-9-21.9-19.6-25.8-28.7-2.2-5.1-2.8-9.6-.6-12.7 2.2-3.1 6.7-4 12.3-3.6 9.8.9 22.9 6.2 35.4 15.2z",
  fill: "#0e0f23"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18640.6 15952.1c6-8.4 17.6-12.1 32.6-10.9 20.7 1.7 48.1 12.8 74.5 31.6 26.3 18.9 45.6 41.4 53.8 60.4 6 13.8 6.2 26 .2 34.4l-41.2 57.6c-6 8.4-17.7 12.1-32.6 10.9-20.7-1.8-48.2-12.8-74.5-31.7-26.4-18.8-45.6-41.3-53.9-60.3-6-13.8-6.2-26-.2-34.4l41.3-57.6zm155.4 111.4v-.1c4.8-6.6 3.8-16.4-.9-27.4-7.9-18.1-26.4-39.4-51.6-57.4-25.1-18-51.2-28.7-70.9-30.3-12-1-21.5 1.2-26.3 7.9l-.2.4c-4.5 6.7-3.5 16.2 1.2 27 7.9 18.2 26.4 39.5 51.5 57.5s51.2 28.7 70.9 30.3c11.8.9 21.1-1.2 26-7.5l.3-.5v.1zm-64.2-68.6c12.6 9 21.9 19.7 25.8 28.8 2.3 5.1 2.9 9.6.6 12.7-2.2 3.1-6.7 4-12.2 3.5-9.9-.8-22.9-6.2-35.5-15.2-12.6-9-21.9-19.6-25.8-28.7-2.2-5.1-2.8-9.6-.6-12.7 2.2-3.1 6.7-4 12.3-3.6 9.8.9 22.9 6.2 35.4 15.2z"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17004.5 15714.1c1.1 0 2.9-1.1 3.9-1.4 3.5-1.1 7-2.2 10.6-3.1 10.5-2.7 21.4-4.2 32.2-3.2 17 1.6 32.4 14.1 49.5 12.4 9.6-.9 16.4-6.6 24.8-10.5 8-3.9 16.8-5.6 25.7-4.8 26.5 2.2 36.5 24.2 63.4 23 22.3-1 13.6-12.3 35-16.3.2-.1 51.7 19 52.1 22.3 1.5 12.7-27.1 162.3-25.8 162.3l-255.1-39.5-16.3-141.2z",
  fill: "url(#_Linear2)",
  transform: "matrix(1 0 0 -2.3719 1581.65 53337.7)"
})));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M18607.7 16015.7c1.1 26.3 27 51.4 46.9 68.4 27.7 23.6 72.3 41.3 97.2 37.3",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 3,
  strokeDasharray: "6,6,75,75",
  strokeDashoffset: 3,
  transform: "matrix(2.22208 0 0 2.22208 -41234.303 -35478.769)"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "_Linear2",
  x1: 0,
  y1: 0,
  x2: 1,
  y2: 0,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(27.908 -59.2347 -140.499 -11.7661 17095.7 15766.6)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#27b0e6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.52,
  stopColor: "#c26bb3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fa52a0"
})));

function SvgSushi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSushi);
export default __webpack_public_path__ + "static/media/Sushi.0cce47c9.svg";
export { ForwardRef as ReactComponent };